import { useState } from "react";
import { showMessage } from "../../messages";
import { hideAll, showError, showOk } from "../../component-utils/NotificationModals";
import { fetchApiPost } from "../../Requests";
import { useNavigate } from "react-router-dom";

export function DonatePopUp({ donate, setDialog }) {
  const [username, setUsername] = useState("");
  const [amount, setAmount] = useState(donate.minAmount.toString());
  const [checked, setChecked] = useState(false);
  const [creatingOrder, setCreatingOrder] = useState(false);
  const [iframe, setIFrame] = useState(null);

  const buy = () => {
    if (creatingOrder) {
      return;
    }

    let intAmount = parseInt(amount);
    if (isNaN(intAmount)) {
      showMessage("Некорректно указано количество");
      return;
    }

    if (!checked) {
      showMessage("donate.checkbox");
    } else if (username.length < 4 || username.length > 16) {
      showMessage("register.bad_username");
    } else {
      hideAll();
      showOk("Создаём счёт...");

      setCreatingOrder(true);
      fetchApiPost("create_order", {
        "username": username,
        // "email": email,
        "product": donate.id,
        "amount": intAmount
      }, false).then(([response, text]) => {
        setCreatingOrder(false);
        if (response.status === 200) {
          window.open(text);
          setDialog(null);
        } else {
          showError(text);
        }
      });
    }
  }

  if (iframe) {
    return (
      <dialog id="donate-dialog" style={{ "width": "80%", "height": "80%" }} onClose={() => setDialog(null)}>
        <iframe
          sandbox="allow-top-navigation allow-same-origin allow-scripts allow-popups allow-forms"
          style={{ width: '100%', height: '100%', border: 'none', zIndex: '1000' }}
          srcDoc={iframe}
        />

        <button className="close-modal-btn" onClick={() => setDialog(null)}>
          <i className="fa-solid fa-xmark fa-2xl"></i>
        </button>
      </dialog>
    )
  }

  return (
    <dialog id="donate-dialog" onClose={() => setDialog(null)}>
      <div className="modal-box" id="donate-modal-box">
        <div className="modal-header">
          <h2>Оформление платежа</h2>
        </div>

        <div className="modal-columns">
          <a
            className="launcher-button"
          >
            <img style={{ "maxWidth": "10%" }} src={donate.image} alt={donate.title} />
            <div className="launcher-text">
              <h3 className="launcher-heading">{donate.title}</h3>
              <span className="launcher-under-text">
                {donate.cost}₽
              </span>
            </div>
          </a>

          <input
            type="text"
            maxLength={16}
            placeholder="Игровой никнейм на сервере"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          {donate.maxAmount != donate.minAmount &&
            <div style={{"display": "flex", "gap": "20px", "alignItems": "center"}}>
              Количество
              <input
                type="number"
                placeholder="Количество"
                value={amount}
                onChange={(e) => {
                  let newValue = parseInt(e.target.value);
                  if (isNaN(newValue) || newValue < donate.minAmount) {
                    newValue = donate.minAmount;
                  } else if (newValue > donate.maxAmount) {
                    newValue = donate.maxAmount;
                  }
                  setAmount(newValue.toString());
                }}
              />
            </div>
          }

          <div style={{ "width": "100%" }}>
            <input
              type="checkbox"
              id="slim-skin-checkbox"
              checked={checked}
              onChange={(e) => {
                setChecked(!checked);
              }}
              style={{ "marginRight": "10px" }}
            />
            Я прочитал и соглашаюсь с {" "}
            <a style={{ "color": "#B3B7BC" }} href="/offer" target="_blank">
              <u>офертой</u>
            </a>
            {" и "}
            <a style={{ "color": "#B3B7BC" }} href="/rules" target="_blank">
              <u>правилами использования</u>
            </a>
            {" "} KachanovCraft
          </div>

          <div className="button donate-button" onClick={buy}>
            Купить
          </div>
        </div>

        <button className="close-modal-btn" onClick={() => setDialog(null)}>
          <i className="fa-solid fa-xmark fa-2xl"></i>
        </button>
      </div>

      <div id="error-dialog" style={{ display: "none" }}>
        <div className="modal-box" id="error-modal-box">
          <img src="images/ban.png" alt="ban" />
          <span className="error-text" id="error-text"></span>
        </div>
      </div>

      <div id="ok-dialog" style={{ display: "none" }}>
        <div className="modal-box" id="ok-modal-box">
          <img src="images/ok.png" alt="ok" />
          <span className="ok-text" id="ok-text"></span>
        </div>
      </div>
    </dialog>
  );
}
